const biRewardsApi = require('services/api/beautyInsider');
const UtilActions = require('utils/redux/Actions');

function fetchBiRewards() {
    return dispatch => {
        biRewardsApi.getBiRewardsGroupForSnapshot()
            .then(data => {
                const { biRewardGroups } = data;
                dispatch(UtilActions.merge('beautyInsider', 'biRewardGroups', biRewardGroups));
            })
            .catch(error => {
                dispatch(UtilActions.merge('beautyInsider', 'biRewardGroups', error));
            });
    };
}

function fetchClientSummary(profileId, includeCampaigns) {
    return dispatch => {
        biRewardsApi.getClientSummary(profileId, includeCampaigns)
            .then(summary => {
                dispatch(UtilActions.merge('beautyInsider', 'summary', summary));
            })
            // eslint-disable-next-line no-console
            .catch(console.error);
    };
}

module.exports = {
    fetchBiRewards,
    fetchClientSummary
};
